import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { ClientLpAction } from '../clientLp.action';

export const endClientLpProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    ClientLpAction.update.done,
    ClientLpAction.update.failed,
  ),
  mergeMap(() => {
    return [
      ClientLpAction.processing.done({}),
    ];
  }),
);
